<template>
  <div class="invoice-customer-card">
    <v-card-text class="pa-4">
      <div class="customer-select-grid">
        <div>
          <div class="field-label">Customer</div>
          <AutoComplete
            :disabled="disableCustomer"
            v-model="selectedCustomer"
            @reset="$emit('reset')"
            @change="customerChange"
            :initValue="setCustomer"
            :errorMessages="selectCustomerError"
          />
        </div>

        <div>
          <div class="field-label">Sales Rep</div>
          <SalesMan v-model="selectedUser" :initValue="initRep" />
        </div>
      </div>

      <v-expansion-panels v-if="selectedCustomer" flat class="selected-customer-panel">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="customer-summary">
              <div>
                <div class="customer-name">{{ selectedCustomer.name }}</div>
                <div class="customer-address">
                  {{ selectedCustomer.address }}
                  <span v-if="selectedCustomer.city">
                    {{ selectedCustomer.city }}, {{ selectedCustomer.state }} {{ selectedCustomer.zip }}
                  </span>
                </div>
              </div>

              <div>
                <div class="balance-label">Balance</div>
                <div class="balance-value">{{ selectedCustomer.balance | currency }}</div>
              </div>
            </div>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <div class="detail-grid">
              <v-textarea
                v-if="selectedCustomer"
                readonly
                outlined
                hide-details
                dense
                rows="2"
                auto-grow
                v-model="selectedCustomer.note"
                label="Customer Note"
              />

              <v-textarea
                outlined
                dense
                hide-details
                rows="2"
                auto-grow
                v-model="Invoice.note"
                label="Invoice Note"
              />
            </div>

            <div class="date-grid">
              <DateSelector
                label="Date"
                :initValue="initDate"
                v-model="Invoice.date"
              />

              <DateSelector
                label="Due Date"
                :initValue="initDueDate"
                v-model="Invoice.dueDate"
              />

              <v-text-field
                outlined
                hide-details
                dense
                v-model="Invoice.trackingNumber"
                label="Tracking Number"
              />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </div>
</template>

<script>
import DateSelector from "@/components/DateSelector";
import { mapGetters, mapActions } from "vuex";
import AutoComplete from "@/modules/Customer/components/AutoComplete";
import SalesMan from "@/modules/User/components/AutoComplete.vue";
// const Edit = () => import("@/modules/Customer/components/Edit");

// this.$moment().toISOString(),
export default {
  props: {
    selectCustomerError: {
      default: function () {
        return [];
      },
    },
    initCustomer: {
      type: Object,
      default: null,
    },
    initUser: {
      default: null,
    },
    initInvoice: {
      default: null,
    },
  },
  data() {
    return {
      disableCustomer: false,
      editDialog: false,
      initRep: null,
      setCustomer: null,
      initDate: null,
      initDueDate: null,
    };
  },
  components: {
    DateSelector,
    AutoComplete,
    SalesMan,
  },
  created() {
    // // console.log("this.Invoice.Date", this.Invoice.date);

    if (this.Invoice.date) {
      this.SetInvoiceDate(this.$moment(this.Invoice.date).toISOString());
    } else {
      this.SetInvoiceDate(this.$moment().toISOString());
    }

    if (this.Invoice.dueDate) {
      this.SetInvoiceDate(this.$moment(this.Invoice.dueDate).toISOString());
    } else {
      this.SetInvoiceDate(this.$moment().toISOString());
    }
    // this.SetInvoiceDate(this.$moment(this.Invoice.date).toISOString());
    // this.SetInvoiceDueDate(this.$moment(this.Invoice.dueDate).toISOString());

    // if (this.$route.query && this.$route.query.CustomerId) {
    //   const id = this.$route.query.CustomerId;
    // this.initCustomer = id;
    // }
    // console.log("initCustomer", this.initCustomer);
    // console.log("initCustomer", this.initRep);
  },
  watch: {
    initUser(val) {
      // Edit Invoice passes the Sales Rep user itself, not an object with a
      // nested SalesRep property.
      this.initRep = val || (this.initCustomer && this.initCustomer.SalesRep);
    },
    initInvoice(val) {
      // console.log("initInvoice", val);
      this.initDate = val.date;
      this.initDueDate = val.dueDate;
      if (val.PaymentDetails.length > 0) {
        this.disableCustomer = true;
      } else {
        this.disableCustomer = false;
      }
    },
    initCustomer(val) {
      // Prefer the rep saved on the invoice. The customer's default rep is
      // only a fallback when the invoice does not already have one.
      this.initRep = this.initUser || (val && val.SalesRep);
      this.setCustomer = val;
      this.selectedCustomer = val;
    },
  },
  computed: {
    ...mapGetters("invoice", [
      "InvoiceDetails",
      "Invoice",
      "invoiceTotal",
      "getSelectedUser",
      "getSelectedCustomer",
      "getTrackingNumber",
      "currentUser",
    ]),
    ...mapGetters("global", ["currentUser", "currentBusiness"]),
    invoiceDueDate: {
      get: function () {
        return this.getInvoiceDueDate;
      },
      set: function (val) {
        this.SetInvoiceDueDate(val);
      },
    },
    invoiceDate: {
      get: function () {
        return this.getInvoiceDate;
      },
      set: function (val) {
        this.SetInvoiceDate(val);
      },
    },
    invoiceNote: {
      get: function () {
        return this.getInvoiceNote;
      },
      set: function (val) {
        this.SetInvoiceNote(val);
      },
    },
    trackingNumber: {
      get: function () {
        return this.getTrackingNumber;
      },
      set: function (val) {
        this.SetTrackingNumber(val);
      },
    },
    selectedCustomer: {
      get: function () {
        return this.getSelectedCustomer;
      },
      set: function (val) {
        this.SetSelectedCustomer(val);
      },
    },
    selectedUser: {
      get: function () {
        return this.getSelectedUser;
      },
      set: function (val) {
        this.SetSelectedUser(val);
      },
    },
  },
  methods: {
    ...mapActions("invoice", [
      "SetSelectedCustomer",
      "SetTrackingNumber",
      "SetInvoiceDueDate",
      "SetInvoiceDate",
      "SetSelectedUser",
    ]),
    customerChange(val) {
      if (val && val.SalesRep) {
        this.initRep = val.SalesRep;
      }
      if (val && val.metadata && val.metadata.invoiceDue) {
        this.initDueDate = this.$moment()
          .add(val.metadata.invoiceDue.value, "days")
          .toISOString();
        this.SetInvoiceDueDate(
          this.$moment()
            .add(val.metadata.invoiceDue.value, "days")
            .toISOString()
        );
      } else if (this.currentBusiness.metadata.invoiceDue) {
        this.initDueDate = this.$moment()
          .add(this.currentBusiness.metadata.invoiceDue.value, "days")
          .toISOString();
        this.SetInvoiceDueDate(
          this.$moment()
            .add(this.currentBusiness.metadata.invoiceDue.value, "days")
            .toISOString()
        );
      } else {
        this.initDueDate = this.$moment().toISOString();
        this.SetInvoiceDueDate(this.$moment().toISOString());
      }
    },
  },
};
</script>

<style scoped>
.invoice-customer-card {
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
}

.customer-select-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(220px, 320px);
  gap: 14px;
}

.field-label {
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 6px;
}

.selected-customer-panel {
  margin-top: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
}

.customer-summary {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.customer-name {
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
  text-transform: capitalize;
}

.customer-address {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.balance-label {
  font-size: 11px;
  color: #64748b;
  text-align: right;
}

.balance-value {
  font-size: 16px;
  font-weight: 900;
  color: #0f172a;
  text-align: right;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.date-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 12px;
}

@media (max-width: 960px) {
  .customer-select-grid,
  .detail-grid,
  .date-grid {
    grid-template-columns: 1fr;
  }

  .customer-summary {
    align-items: flex-start;
    flex-direction: column;
  }

  .balance-label,
  .balance-value {
    text-align: left;
  }
}
</style>
